const MAIN_VIEW_MODEL = Object.freeze({
  userSettings: 'App/UserSettings',
  userAccount: 'App/UserAccount',
});

export default MAIN_VIEW_MODEL;
